import React from 'react'
import header from '../img/header.png'

function Banner() {
    return <img className='header-img' src={header} />
}

export default Banner